import { render, staticRenderFns } from "./ObjectPreview.vue?vue&type=template&id=4af8b330&scoped=true&"
import script from "./ObjectPreview.vue?vue&type=script&lang=ts&"
export * from "./ObjectPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ObjectPreview.vue?vue&type=style&index=0&id=4af8b330&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af8b330",
  null
  
)

export default component.exports